/**
 * util url module
 * @module util/url
 * @example
 * import WSLib from '@tencent/weishi-lib';
 * WSLib.wsUtil.url.parseUrl('https://xxx.xxx.com?a=1&b=2');
 */
import { isDate, isObject } from './type';
import { getToken, getPskeyToken } from './token';

/**
 * get params object from url
 * @param {String} url url string
 */
export function parseUrl(url) {
  const a = document.createElement('a');
  let rs = {};
  a.href = url;
  rs = {
    params: (function () {
      const ret = {};
      const seg = a.search.replace(/^\?/, '').split('&');
      const len = seg.length;
      let i = 0;
      for (; i < len; i += 1) {
        if (!seg[i]) {
          // eslint-disable-next-line no-continue
          continue;
        }
        const pos = seg[i].indexOf('=');
        ret[seg[i].substr(0, pos)] = decodeURIComponent(escape(seg[i].substr(pos + 1)))
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\x60/g, '&#96;')
          .replace(/\x27/g, '&#39;')
          .replace(/\x22/g, '&quot;');
      }
      return ret;
    }()),
  };
  return rs;
}

/**
 * build url params
 * @param {String} url url
 * @param {Object} params params
 * @param {Boolean} withGTK with g_tk
 */
export function buildUrl(url, params, withGTK) {
  let newUrl = url;

  if (withGTK) {
    let gTk = '';
    if (newUrl.indexOf('qzone.qq.com') >= 0
      || newUrl.indexOf('abcmouse.qq.com') >= 0
      || newUrl.indexOf('weishi.qq.com') >= 0
      || newUrl.indexOf('fm.qq.com') >= 0) {
      gTk = getPskeyToken();
    } else {
      gTk = getToken();
    }
    newUrl += `${newUrl.indexOf('?') === -1 ? '?' : '&'}g_tk=${gTk}`;
  }

  if (!params || typeof params !== 'object') {
    return newUrl;
  }

  let serializedParams = '';
  const parts = [];
  Object.keys(params).forEach((key) => {
    let val = params[key];
    if (isDate(val)) {
      val = val.toISOString();
    } else if (isObject(val)) {
      val = JSON.stringify(val);
    }
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
  });
  serializedParams = parts.join('&');

  if (serializedParams) {
    const hashmarkIndex = newUrl.indexOf('#');
    if (hashmarkIndex !== -1) {
      newUrl = newUrl.slice(0, hashmarkIndex);
    }

    newUrl += (newUrl.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return newUrl;
}

/**
 * get params object
 * @param {String} url
 */
export function getQueryObj(url) {
  const newUrl = url || window.location.href;
  return parseUrl(newUrl).params;
}

export default {
  parseUrl,
  buildUrl,
  getQueryObj,
};
